module.exports = __webpack_public_path__ + "img/入党誓词.eca7195c.png";